import React, { useEffect, useState } from "react";
import Layout from "../../common/layout";
import { useTranslation } from "react-i18next";
import ListTable from "../../../elements/list/list";
import { Container } from "../../common/layout/styels";
const UserType = (props) => {
  const { t } = useTranslation();
  const [attributes] = useState([
    {
      type: "text",
      placeholder: "title",
      name: "title",
      validation: "",
      default: "",
      label: "title",
      required: true,
      view: true,
      add: true,
      update: true,
    },
    {
      type: "text",
      placeholder: "role",
      name: "role",
      validation: "",
      default: "",
      label: "role",
      required: true,
      view: true,
      add: true,
      update: true,
    },{
      type: "textarea",
      placeholder: "description",
      name: "description",
      validation: "",
      default: "",
      label: "description",
      required: true,
      view: true,
      add: true,
      update: true,
    },
  ]);

  //to update the page title
  useEffect(() => {
    document.title = `${t("userRoles")} - Whistleblowing24`;
  }, [t]);

  // const [actions] = useState([{ element: "button", type: "subList", id: "designation", itemTitle: "title", icon: "designation", title: "designation", attributes: designation, params: { api: `designation`, itemTitle: "title", shortName: "designation", addPrivilege: true, delPrivilege: true, updatePrivilege: true, datefilter: false, customClass: "medium" } }]);

  return (
    <Container className="noshadow">
      <ListTable {...props}  api={`user-type`} itemTitle={`title`} shortName={`userRoles`} addPrivilege={true} delPrivilege={false} updatePrivilege={true} attributes={attributes}></ListTable>
    </Container>
  );
};
// exporting the page with parent container layout..
export default Layout(UserType);
